
@if (canEdit) {
  <div class="grid-x" [formGroup]="form">
    @if (editingField != 'streetAddress') {
      <div class="cell large-12 medium-12 small-12">
        {{streetAddress}}
        <button (click)="editField('streetAddress')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editStreet" aria-describedby="editStreetIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editStreetIcon">Edit Street Address</span>
      </div>
    } @else {
      <div class="cell large-9 medium-9 small-9 padding-right">
        <input type="text" formControlName="streetAddress" id="streetAddress" aria-describedby="addressInput" />
        <span class="show-for-sr" id="addressInput">Input a Street Address</span>
      </div>
      <div class="cell large-3 medium-3 small-3">
        <button id="updateStreet" aria-describedby="updateStreetButton" class="button" (click)="update('streetAddress')">
          <svg-icon icon="icon-save" class="small black" id="updateStreetIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updateStreetButton">Update Street Address</span>
      </div>
    }
    @if (editingField != 'suite') {
      <div class="cell large-12 medium-12 small-12">
        Suite: {{ address.suite }}
        <button (click)="editField('suite')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editSuite" aria-describedby="editSuiteIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editSuiteIcon">Edit Suite</span>
      </div>
    } @else {
      <div class="cell small-2 medium-2 large-2 padding-right">
        Suite:
      </div>
      <div class="cell large-7 medium-7 small-7 padding-right">
        <input type="text" formControlName="suite" id="suite" aria-describedby="suiteInput" />
        <span class="show-for-sr" id="suiteInput">
          Input a Suite
        </span>
      </div>
      <div class="cell large-3 medium-3 small-3">
        <button id="updateSuite" aria-describedby="updateSuiteButton" class="button" (click)="update('suite')">
          <svg-icon icon="icon-save" class="small black" id="updateSuiteIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updateSuiteButton">Update Suite</span>
      </div>
    }
    @if (editingField != 'poBox') {
      <div class="cell large-12 medium-12 small-12">
        PO Box:  {{ address.poBox }}
        <button (click)="editField('poBox')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editPoBox" aria-describedby="editPoBoxIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editPoBoxIcon">Edit PO Box</span>
      </div>
    } @else {
      <div class="cell small-3 medium-3 large-3 padding-right">
        PO Box:
      </div>
      <div class="cell large-6 medium-6 small-6 padding-right">
        <input type="text" formControlName="poBox" id="poBox" aria-describedby="poBoxInput" />
        <span class="show-for-sr" id="poBoxInput">
          Input a Post Office Box
        </span>
      </div>
      <div class="cell large-3 medium-3 small-3">
        <button id="updatePoBox" aria-describedby="updatePoBoxButton" class="button" (click)="update('poBox')">
          <svg-icon icon="icon-save" class="small black" id="updatePoBoxIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updatePoBoxButton">Update PO Box</span>
      </div>
    }
    @if (editingField != 'city') {
      <div class="cell large-5 medium-5 small-5">
        {{ address.city }}
        <button (click)="editField('city')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editCity" aria-describedby="editCityIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editCityIcon">Edit City</span>,
      </div>
    } @else {
      <div class="cell small-4 medium-4 large-4 padding-right">
        <input type="text" formControlName="city" id="city" aria-describedby="cityInput" />
        <span class="show-for-sr" id="cityInput">
          Input a City
        </span>
      </div>
      <div class="cell small-1 medium-1 large-1">
        <button id="updateCity" aria-describedby="updateCityButton" class="button" (click)="update('city')">
          <svg-icon icon="icon-save" class="small black" id="updateCityIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updateCityButton">Update City</span>
      </div>
    }
    @if (editingField != 'state') {
      <div class="cell large-3 medium-3 small-3">
        {{ address.stateCode }}
        <button (click)="editField('state')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editState" aria-describedby="editStateIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editStateIcon">Edit State</span>
      </div>
    } @else {
      <div class="cell small-2 medium-2 large-2 padding-right">
        <select formControlName="state" id="state" aria-describedby="stateSelector">
          @for (state of states; track state) {
            <option [value]="state.Code">{{state.Code}}</option>
          }
        </select>
        <span class="show-for-sr" id="stateSelector">
          Select a State
        </span>
      </div>
      <div class="cell small-1 medium-1 large-1">
        <button id="updateState" aria-describedby="updateStateButton" class="button" (click)="update('state')">
          <svg-icon icon="icon-save" class="small black" id="updateStateIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updateStateButton">Update State</span>
      </div>
    }
    @if (editingField != 'zipCode') {
      <div class="cell large-3 medium-3 small-3">
        {{ address.zipCode }}
        <button (click)="editField('zipCode')" class="button">
          <svg-icon icon="icon-pencil" class="small black" id="editZipCode" aria-describedby="editZipCodeIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="editZipCodeIcon">Edit Zip Code</span>
      </div>
    } @else {
      <div class="cell small-2 medium-2 large-2 padding-right">
        <input type="text" formControlName="zipCode" id="zipCode" aria-describedby="zipInput" />
        <span class="show-for-sr" id="zipInput">
          Input a Zip Code
        </span>
      </div>
      <div class="cell small-1 medium-1 large-1">
        <button id="updateZip" aria-describedby="updateZipButton" class="button" (click)="update('zipCode')">
          <svg-icon icon="icon-save" class="small black" id="updateZipIcon"></svg-icon>
        </button>
        <span class="show-for-sr" id="updateZipButton">Update Zip Code</span>
      </div>
    }
  </div>
} @else {
  @if (address) {
    <div>{{ address.street }} @if (address.suite) {
      Suite {{ address.suite }}
    }</div>
    @if (address.poBox) {
      PO Box {{ address.poBox }}
    }
    <div>{{ address.city }}, {{ address.stateCode }} {{ address.zipCode }}</div>
  }
}

